import {
  Box,
  HStack,
  InlineFormattedNumber,
  NumberVariants,
  SummaryLineWrapper,
  Total,
  toBigWithDefault,
  type LedgerEvent,
} from '@talos/kyoko';
import Big from 'big.js';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

interface LedgerEventsBlotterSummaryLineProps {
  rows: LedgerEvent[];
}

export const LedgerEventsBlotterSummaryLine = ({ rows }: LedgerEventsBlotterSummaryLineProps) => {
  const { colors } = useTheme();
  const total = useMemo(() => {
    let agg = Big(0);
    rows.forEach(row => {
      const value = toBigWithDefault(row?.Amount, 0);
      agg = agg.plus(value);
    });
    return agg;
  }, [rows]);

  const currency = rows.at(0)?.AmountAsset;

  return (
    <SummaryLineWrapper alignItems="center" w="100%" data-testid="ledger-events-summary">
      <HStack px="spacing4">
        <Total data-testid="ledger-events-summary-label">Total Amount Selected:</Total>
        <Box data-testid="ledger-events-summary-value">
          <InlineFormattedNumber
            background={colors.gray['010']}
            number={total}
            currency={currency}
            variant={total.lt(0) ? NumberVariants.Negative : undefined}
            truncate={false}
          />
        </Box>
      </HStack>
    </SummaryLineWrapper>
  );
};
